import logoutUser from '../logout';
import gqlClient from '../client/gqlClient';
import gql from 'graphql-tag';

export const queryCampaignTargetingOptions = async campaignId => {
    try {
        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }
        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }
        const result = await gqlClient.client.query({
            query: gql`
                query CampaignTargetingOptions($campaignId: ID!) {
                    campaignTargetingOptions(campaignId: $campaignId) {
                        campaignId
                        categories {
                            primaryCategoryName
                            subCategories {
                                subCategoryName
                            }
                        }
                        gender
                        age {
                            minAge
                            maxAge
                        }
                        languages {
                            name
                        }
                        locations {
                            name
                        }
                        followers {
                            minFollowers
                            maxFollowers
                        }
                        followersTiers
                        avgEngagements
                        engagementRate
                    }
                }
            `,
            variables: {campaignId}
        });

        const {campaignTargetingOptions} = result.data;

        if (campaignTargetingOptions) {
            const campaignHasTargetingOptions = Object.keys(campaignTargetingOptions)
                .filter(k => !['__typename', 'campaignId'].includes(k))
                .some(prop => campaignTargetingOptions[prop] !== null);

            return campaignHasTargetingOptions ? campaignTargetingOptions : null;
        }

        return null;
    } catch (error) {
        if (error.message.includes('401')) {
            return logoutUser();
        }
        throw error;
    }
};



// WEBPACK FOOTER //
// ./graphql/queries/queryCampaignTargetingOptions.js